import { render, staticRenderFns } from "./indexGoods.vue?vue&type=template&id=e1ae6af2&scoped=true&"
import script from "./indexGoods.vue?vue&type=script&lang=js&"
export * from "./indexGoods.vue?vue&type=script&lang=js&"
import style0 from "./indexGoods.vue?vue&type=style&index=0&id=e1ae6af2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ae6af2",
  null
  
)

export default component.exports